import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ForgeProvider from "@components/ForgeProvider";
import MyTasks from "@routes/MyTasks";
import Admin from "@routes/Admin";
import { OrdersContextProvider } from "@contexts/orders-context";
import { AppStateContextProvider } from "@contexts/app-state";
import { MetricsContextProvider } from "./contexts/metrics-context";
import App from "./App";
import "./index.css";
import Metrics from "./routes/Metrics";
import TaoRouting from "./routes/TaoRouting";
import TaoEditorContainer from "./routes/TaoEditor";
import { TaoRulesContextProvider } from "./contexts/tao-rule-context";
import { BannerContextProvider } from "./contexts/banner-context";
import ErrorPage from "./components/ErrorPage";

const router = createBrowserRouter([
  {
    path: "/",

    element: <App />,
    children: [
      {
        path: "/my-tasks",
        element: (
          <OrdersContextProvider>
            <MyTasks />
          </OrdersContextProvider>
        ),
      },
      {
        path: "/admin",
        element: (
          <OrdersContextProvider>
            <Admin />
          </OrdersContextProvider>
        ),
      },
      {
        path: "user-activity",
        element: (
          <OrdersContextProvider>
            <MetricsContextProvider>
              <Metrics />
            </MetricsContextProvider>
          </OrdersContextProvider>
        ),
      },
      {
        path: "tao-routing",
        element: (
          <TaoRulesContextProvider>
            <TaoRouting />
          </TaoRulesContextProvider>
        ),
      },
      {
        path: "tao-routing/tao-editor",
        element: <TaoEditorContainer />,
      },
      {
        path: "/error",
        element: <ErrorPage />,
      },
    ],
  },
], {
  basename: '/__BASE_PATH__',
});

const container = document.getElementById("root");

if (!container) throw new Error("Failed to find container element");
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
  <AppStateContextProvider>
    <QueryClientProvider client={queryClient}>
      <BannerContextProvider>
        <ForgeProvider>
          <RouterProvider router={router} />
        </ForgeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </BannerContextProvider>
    </QueryClientProvider>
  </AppStateContextProvider>,
);
